import { render, staticRenderFns } from "./PendingDevicesTable.vue?vue&type=template&id=31f642a1"
import script from "./PendingDevicesTable.vue?vue&type=script&lang=js"
export * from "./PendingDevicesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports